import * as React from 'react';
import { SVGProps, memo } from 'react';

const SvgChevronUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 1400 1400"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <defs>
      <path d="M0 0h7.472v15.053H0V0Z" id="chevron-up_svg__a" />
    </defs>
    <g transform="matrix(87.5 0 0 87.5 47 350)">
      <g transform="rotate(-90 3.892 3.844)" fill="none" fillRule="evenodd">
        <mask id="chevron-up_svg__b" fill="#fff">
          <use xlinkHref="#chevron-up_svg__a" />
        </mask>
        <path
          d="m0 .724 5.618 6.704L0 14.132l1.189.724L7.41 7.428 1.19 0Z"
          fill={props.color}
          mask="url(#chevron-up_svg__b)"
        />
      </g>
    </g>
  </svg>
);

const Memo = memo(SvgChevronUp);
export default Memo;
